import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Radio,
  Select,
  Space,
  Tabs,
  Timeline,
  Upload,
} from "antd";
import {
  BackIcon,
  DateIcon,
  DotHour,
  TabDriverJob2,
  TabDriverProfile2,
  TrashIcon,
  UploadIcon,
} from "../../../../asset";
import { t } from "i18next";
import style from "./DriverAdd.module.css";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import { ROUTES } from "../../../../constant/routeConstant";
import { TabDriverProfile, TabDriverJob } from "../../../../asset";
import _ from "lodash";
import Dragger from "../../../../component/dragger/Dragger";
import MSSDayOff from "../../../../component/select/MSSDayOff";
import axios from "axios";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import { validDriver } from "./validation";
import { setTitle } from "../../../../store/reducer/authentication.reducer";
import { GROLOG_URL, TOKEN } from "../../../../constant/apiConstant";
import moment from "moment";
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";
import ModalSuccessAdd from "../../../../component/modal/ModalSuccessAdd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { onChanged } from "../../../../util/Util";
import dayjs from "dayjs";
import {
  LoadingOption,
  dropdownCustom,
  selectOption,
} from "../../../../component/select/SelectOption";
import MSSAddDayOff from "../../../../component/mss/day-off/add-day-off";

const DriverAdd = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState([]);
  const [selectedFileList, setSelectedFileList] = useState([]);
  const [selectedFileList2, setSelectedFileList2] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [country, setCountry] = useState([]);
  const [island, setIsland] = useState([]);
  const [province, setProvince] = useState([]);
  const [district, setDistrict] = useState([]);
  const [subdistrict, setSubdistrict] = useState([]);
  const [urbanvillage, setUrbanvillage] = useState([]);
  const [postalcode, setPostalcode] = useState([]);
  const [title, setTitle] = useState([]);
  const [load, setLoad] = useState(false);
  const [error, setError] = useState();
  const [vehicle, setVehicle] = useState([]);
  const [additional, setAdditional] = useState([]);
  const [date, setDate] = useState("13-04-2023");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [additionalProofs, setAdditionalProofs] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pageCountry, setPageCountry] = useState(1);
  const [limitCountry, setLimitCountry] = useState(10);
  const [filter, setFilter] = useState("");
  const [pageProvince, setPageProvince] = useState(1);
  const [limitProvince, setLimitProvince] = useState(10);
  const [filterProvince, setFilterProvince] = useState("");
  const [pageDistrict, setPageDistrict] = useState(1);
  const [limitDistrict, setLimitDistrict] = useState(10);
  const [filterDistrict, setFilterDistrict] = useState("");
  const [pageSubdistrict, setPageSubdistrict] = useState(1);
  const [limitSubdistrict, setLimitSubdistrict] = useState(10);
  const [filterSubdistrict, setFilterSubdistrict] = useState("");
  const [pageUrbanvillage, setPageUrbanvillage] = useState(1);
  const [limitUrbanvillage, setLimitUrbanvillage] = useState(10);
  const [filterUrbanvillage, setFilterUrbanvillage] = useState("");
  const [pageTitle, setPageTitle] = useState(1);
  const [limitTitle, setLimitTitle] = useState(10);
  const [filterTitle, setFilterTitle] = useState("");
  const [pageVehicle, setPageVehicle] = useState(1);
  const [limitVehicle, setLimitVehicle] = useState(10);
  const [filterVehicle, setFilterVehicle] = useState("");
  const [valueDayOff, setValueDayOff] = useState();
  const dispatch = useDispatch();

  const api = GROLOG_URL;
  const [salesmanType, setSalesmanType] = useState({
    flagCheckAll: true,
    isExclude: false,
    data: [],
  });
  const handleChangeAdditional = (value, index, name) => {
    setChange(true);
    onChanged(dispatch, true);
    const newDetail = [...additionalProofs];
    newDetail[index]["value"] = value.target.value;
    setAdditionalProofs(newDetail);
  };
  const handleChange = (value, name) => {
    onChanged(dispatch, true);
    const isChange=true
    setChange(true);
    if (name === "to_menu") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "country") {
      setIsland([]);
      setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListIsland(value);
      setSearchValue("")
      setFilter("")
      getListProvince(value,1,10,"",isChange);
      let eror = validDriver("country_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["island"]: "",
          ["province"]: "",
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "island") {
      // setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      // getListProvince(value);
      let eror = validDriver("island_id", value, t);
      setSearchValue("")
      setFilter("")
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["province"]: "",
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "province") {
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListDistrict(form.country, value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDriver("province_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "district") {
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListSubdistrict(form.country, value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDriver("district_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "sub_district") {
      setUrbanvillage([]);
      setPostalcode([]);
      getListUrbanvillage(form.country, value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDriver("sub_district_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "urban_village") {
      setPostalcode([]);
      getListPostalCode(form.country, value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDriver("urban_village_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["postal_code"]: "",
        };
      });
    } else if (name === "postal_code") {
      // getListSubdistrict(form.country, value);
      let eror = validDriver("postal_code", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "title") {
      let eror = validDriver("title", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "marital_status") {
      let eror = validDriver("marital_status", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "driving_license_type") {
      let eror = validDriver("driving_license_type", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "employment_status") {
      let eror = validDriver("employment_status", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "vehicle_id") {
      let eror = validDriver("vehicle_id", value, t);
      setError({ ...error, ...eror });
      setSearchValue("")
      setFilter("")
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "salary") {
      let eror = validDriver(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
          ["salary_per_hour"]: value.target.value / 8,
        };
      });
    } else if (name === "birth_date") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: moment(new Date(value)).format("YYYY-MM-DD"),
        };
      });
    }else if (name === "shift_start_hour" || name === "shift_end_hour") {
      let data = Number(value.target.value) > 23 ? 23 : (value.target.value) 
        
      let eror = validDriver(name, data, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: data>=0  ? data : "00"};
      });
    } else if (name === "shift_start_min" || name === "shift_end_min") {
      let data = Number(value.target.value) > 59 ? 59 : (value.target.value)
      let eror = validDriver(name, data, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: data>=0 ? data : "00",
        };
      });
    }else if (name === "validity_period_driving_license") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: moment(new Date(value)).format("YYYY-MM-DD"),
        };
      });
    } else if (name === "register_date") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: moment(new Date(value)).format("YYYY-MM-DD"),
        };
      });
    } else {
      let eror = validDriver(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    }
  };

  const handleBlur = (value, key, index, i)=>{
    // newDetail[i][key] = index === 0 ?(value.length===1 ? "0"+value : value) + ":" + newDetail[i][key].split(":")[1] : newDetail[i][key].split(":")[0] + ":" + (value.length===1 ? "0"+value : value) 
    setForm((prevsValue) => {
      return {
        ...prevsValue,
        [key]: value ? value?.length===1 ? "0"+value : value : "00"
      };
    });
  }

  const getSalesmanType = (value) => {
    let datav=[]
    const val = value?.data.map((el) => el.value.split("-")[0].split(" ")[0]);
    let vals =
      value.data[0]?.value === "All"
        ? ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday","Friday", "Saturday"]
        : value?.data.map((el) => {let v={id:el.id, value:el.id}; datav.push(v)});
    setSalesmanType((prevsValue) => ({
      ...prevsValue,
      data: datav,
      flagCheckAll:value.data[0]?.value === "All" ? true :false
    }));
  };

  console.log("daoff",salesmanType)

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "POST";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (data) => {
    setLoad(true);
    getListCountry(1, 10, "");
    getListTitle(1, 10, "");
    getListVehicle(1, 100, "");
    getListAdditional();
    setLoad(false);
  };

  const isZero = [];
  const getListCountry = async (page, limit, filter) => {
    const currentCountry = [...country];
    let countrys = await doGets(
      `/country?page=${page}&limit=${limit}${
        filter ? `&filter=name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = countrys?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      // if (option.length>=1) {
        setCountry(selectOption(currentCountry, option, "value"));
      // } else {
      //   setCountry(selectOption(isZero, option, "value"));
      // }
      // setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListAdditional = async () => {
    let country = await doGets(
      `/additional-proofs?page=1&limit=50&filter=to_menu eq Driver&${param}`,
      token
    );
    let list = [];
    country?.data?.payload?.data.map((el) => {
      list.push({
        key: el.additional_name,
        value: "",
      });
    });
    setAdditionalProofs(list);
  };


  const getListTitle = async (page, limit, filter) => {
    const currentTitle = [...title];
    let titles = await doGets(
      `/person_title?page=${page}&limit=${limit}${
        filter ? `&filter=name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = titles?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.title,
        };
        option.push(data);
      }
      setTitle(selectOption(currentTitle, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  const getListVehicle = async (page, limit, filter) => {
    const currentVehicle = [...vehicle];
    let vehicles = await doGets(
      `/vehicle?page=${page}&limit=${limit}&filter=depot_id eq ${location?.state}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = vehicles?.data?.payload?.data;
    if (list !== null && list?.length !== undefined) {
      for (let i = 0; i < list?.length; i++) {
        const element = list[i];
        let data = {
          id: element?.vehicle_id,
          value: element?.vehicle_type,
        };
        option.push(data);
      }
      setVehicle(selectOption(currentVehicle, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  // const getListVehicle = async () => {
  //   let country = await doGets(
  //     `/vehicle?page=1&limit=50&filter=depot_id eq ${location?.state}&${param}`,
  //     token
  //   );
  //   let list = [];
  //   country?.data?.payload?.data.map((el) => {
  //     list.push({
  //       value: el.vehicle_id,
  //       label: el.vehicle_type,
  //     });
  //   });
  //   setVehicle(list);
  // };

  const getListIsland = async (id) => {
    let island = await doGets(
      `/island?page=1&limit=50&order=id&filter=country_id eq ${id}&${param}`,
      token
    );
    let list = [];
    island?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.name,
      });
    });
    setIsland(list);
  };

  const getListProvince = async (id, page, limit, filter, isChange) => {
    const currentProvince = [...province];
    let provinces = await doGets(
      `/province?page=${page}&limit=${limit}&filter=country_id eq ${id}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = provinces?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setProvince(selectOption(isZero, option, "value"));   setProvince(selectOption(currentProvince, option, "value"));
      
      } else {
        setProvince(selectOption(currentProvince, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListDistrict = async (id, idprov, page, limit, filter, isChange) => {
    const currentDistrict = [...district];
    let districts = await doGets(
      `/district?page=${page}&limit=${limit}&filter=country_id eq ${id}, province_id eq ${idprov}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setDistrict(selectOption(isZero, option, "value"));
      } else {
        setDistrict(selectOption(currentDistrict, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListSubdistrict = async (
    id,
    idprov,
    page,
    limit,
    filter,
    isChange
  ) => {
    const currentSubdistrict = [...subdistrict];
    let districts = await doGets(
      `/sub_district?page=${page}&limit=${limit}&filter=country_id eq ${id}, district_id eq ${idprov}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setSubdistrict(selectOption(isZero, option, "value"));
      } else {
        setSubdistrict(selectOption(currentSubdistrict, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListUrbanvillage = async (
    id,
    idprov,
    page,
    limit,
    filter,
    isChange
  ) => {
    const currentUrbanvillage = [...urbanvillage];
    let districts = await doGets(
      `/urban_village?page=${page}&limit=${limit}&filter=country_id eq ${id}, sub_district_id eq ${idprov}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setUrbanvillage(selectOption(isZero, option, "value"));
      } else {
        setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListPostalCode = async (id, idprov) => {
    let district = await doGets(
      `/postal_code?page=1&limit=50&order=id&filter=urban_village_id eq ${idprov}&${param}`,
      token
    );
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.code,
      });
    });
    setPostalcode(list);
  };

  const onScrollCountry = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageCountry(pageCountry + 1);
      target.scrollTo(0, target.scrollHeight);
      getListCountry(pageCountry, limitCountry, "");
      // setTimeout(() => {
      //   getListCountry(pageCountry,limitCountry)
      // }, 256);
    }
  };
  const onChangeCountry = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value?.length >= 2) {
      setCountry([]);
      setPageCountry(resetPage);
      // this.setState(
      setTimeout(() => {
        getListCountry(pageCountry, limitCountry, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setCountry([]);
      setFilter(resetFilter);
      setPageCountry(resetPage);
      getListCountry(pageCountry, limitCountry, filter);
    }
  };

  const onScrollProvince = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageProvince(pageProvince + 1);
      target.scrollTo(0, target.scrollHeight);
      getListProvince(form?.country, pageProvince, limitProvince, "");
      // setTimeout(() => {
      //   getListProvince(pageProvince,limitProvince)
      // }, 256);
    }
  };

  const onChangeProvince = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setProvince([]);
      setPageProvince(resetPage);
      // this.setState(
      setTimeout(() => {
        getListProvince(form?.country, pageProvince, limitProvince, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setProvince([]);
      setFilter(resetFilter);
      setPageProvince(resetPage);
      getListProvince(form?.country, pageProvince, limitProvince, filter);
    }
  };

  const onScrollDistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageDistrict(pageDistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListDistrict(
        form?.country,
        form?.province,
        pageDistrict,
        limitDistrict,
        ""
      );
      // setTimeout(() => {
      //   getListDistrict(pageDistrict,limitDistrict)
      // }, 256);
    }
  };

  const onChangeDistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setDistrict([]);
      setPageDistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListDistrict(
          form?.country,
          form?.province,
          pageDistrict,
          limitDistrict,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setDistrict([]);
      setFilter(resetFilter);
      setPageDistrict(resetPage);
      getListDistrict(
        form?.country,
        form?.province,
        pageDistrict,
        limitDistrict,
        filter
      );
    }
  };
  const onScrollSubdistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageSubdistrict(pageSubdistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListSubdistrict(
        form?.country,
        form?.district,
        pageSubdistrict,
        limitSubdistrict,
        ""
      );
      // setTimeout(() => {
      //   getListSubdistrict(pageSubdistrict,limitSubdistrict)
      // }, 256);
    }
  };

  const onChangeSubdistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setSubdistrict([]);
      setPageSubdistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListSubdistrict(
          form?.country,
          form?.district,
          pageSubdistrict,
          limitSubdistrict,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setSubdistrict([]);
      setFilter(resetFilter);
      setPageSubdistrict(resetPage);
      getListSubdistrict(
        form?.country,
        form?.district,
        pageSubdistrict,
        limitSubdistrict,
        filter
      );
    }
  };
  const onScrollUrbanvillage = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageUrbanvillage(pageUrbanvillage + 1);
      target.scrollTo(0, target.scrollHeight);
      getListUrbanvillage(
        form?.country,
        form?.sub_district,
        pageUrbanvillage,
        limitUrbanvillage,
        ""
      );
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onChangeUrbanvillage = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setUrbanvillage([]);
      setPageUrbanvillage(resetPage);
      // this.setState(
      setTimeout(() => {
        getListUrbanvillage(
          form?.country,
          form?.sub_district,
          pageUrbanvillage,
          limitUrbanvillage,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setUrbanvillage([]);
      setFilter(resetFilter);
      setPageUrbanvillage(resetPage);
      getListUrbanvillage(
        form?.country,
        form?.sub_district,
        pageUrbanvillage,
        limitUrbanvillage,
        filter
      );
    }
  };

  const onScrollTitle = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageTitle(pageTitle + 1);
      target.scrollTo(0, target.scrollHeight);
      getListTitle(pageTitle, limitTitle, "");
      // setTimeout(() => {
      //   getListTitle(pageTitle,limitTitle)
      // }, 256);
    }
  };
  const onChangeTitle = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setTitle([]);
      setPageTitle(resetPage);
      // this.setState(
      setTimeout(() => {
        getListTitle(pageTitle, limitTitle, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setTitle([]);
      setFilter(resetFilter);
      setPageTitle(resetPage);
      getListTitle(pageTitle, limitTitle, filter);
    }
  };

  const onScrollVehicle = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPageVehicle(pageVehicle + 1);
      target.scrollTo(0, target.scrollHeight);
      getListVehicle(pageVehicle, limitVehicle, "");
      // setTimeout(() => {
      //   getListVehicle(pageVehicle,limitVehicle)
      // }, 256);
    }
  };
  const onChangeVehicle = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setVehicle([]);
      setPageVehicle(resetPage);
      // this.setState(
      setTimeout(() => {
        getListVehicle(pageVehicle, limitVehicle, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setVehicle([]);
      setFilter(resetFilter);
      setPageVehicle(resetPage);
      getListVehicle(pageVehicle, limitVehicle, filter);
    }
  };
console.log("dayoff", valueDayOff);

  const onSubmit = async () => {
    let driver = {
      // ...form,
      additional_proofs: additionalProofs,
      title: form?.title ? form.title : 0,
      first_name: form?.first_name ? form.first_name : "",
      last_name: form?.last_name ? form.last_name : "",
      birth_date: form?.birth_date ? moment(form.birth_date, 'DD MMMM YYYY').format('YYYY-MM-DD') : "0001-01-01",
      gender: form?.gender ? form.gender : "",
      nik: form?.nik ? form.nik : "",
      phone: form?.phone ? "+62-" + form.phone : "",
      email: form?.email ? form.email : "",
      marital_status: form?.marital_status ? form.marital_status : "",
      country_id: form?.country ? form.country : "",
      island_id: form?.island ? form.island : 0,
      province_id: form?.province ? form.province : "",
      district_id: form?.district ? form.district : "",
      sub_district_id: form?.sub_district ? form.sub_district : "",
      urban_village_id: form?.urban_village ? form.urban_village : "",
      address: form?.address ? form.address : "",
      neighbourhood: form?.neighbourhood ? form.neighbourhood : "",
      hamlet: form?.hamlet ? form.hamlet : "",
      postal_code: form?.postal_code ? form.postal_code : "",
      longitude: form?.longitude ? form.longitude : "",
      latitude: form?.latitude ? form.latitude : "",
      register_date: form?.register_date ? form.register_date : "0001-01-01",
      employment_status: form?.employment_status,
      emergency_contact_name: form?.emergency_contact_name
        ? form.emergency_contact_name
        : "",
      emergency_contact_relationship: form?.emergency_contact_relationship
        ? form.emergency_contact_relationship
        : "",
      emergency_contact_phone: form?.emergency_contact_phone
        ? "+62-" + form.emergency_contact_phone
        : "",
      emergency_contact_address: form?.emergency_contact_address
        ? form.emergency_contact_address
        : "",
      depot_id: location.state,
      shift_start_time:
        (form?.shift_start_hour ? form?.shift_start_hour : "00") +
        ":" +
        (form.shift_start_min ? form.shift_start_min : "00"),
      shift_end_time:
        (form?.shift_end_hour ? form?.shift_end_hour : "00") +
        ":" +
        (form.shift_end_min ? form.shift_end_min : "00"),
        day_off:valueDayOff.toString(),
      // day_off: salesmanType?.flagCheckAll ? ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday","Friday", "Saturday"].toString() : salesmanType?.data?.map((el)=>el.id)?.toString(),
      salary: form.salary ? form.salary : "",
      salary_per_hour: form.salary_per_hour ? form.salary_per_hour : "",
      vehicle_id: form.vehicle_id ? form.vehicle_id : 0,
      driving_license_type: form.driving_license_type
        ? form.driving_license_type
        : 0,
      driving_license_number: form.driving_license_number
        ? form.driving_license_number
        : "",
      validity_period_driving_license: form.validity_period_driving_license
        ? form.validity_period_driving_license
        : "0001-01-01",
    };

    let errors = {};
    let datajob = {
      shift_start_hour: form.shift_start_hour ? form.shift_start_hour : "",
      shift_end_hour: form.shift_end_hour ? form.shift_end_hour : "",
      shift_start_min: form.shift_start_min ? form.shift_start_min : "",
      shift_end_min: form.shift_end_min ? form.shift_end_min : "",
      day_off: salesmanType?.flagCheckAll ? ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday","Friday", "Saturday"].toString() : salesmanType?.data?.map((el)=>el.id)?.toString(),
      salary: form.salary ? form.salary : "",
      salary_per_hour: form.salary_per_hour ? form.salary_per_hour : "",
      vehicle_id: form.vehicle_id ? form.vehicle_id : 0,
      driving_license_type: form.driving_license_type
        ? form.driving_license_type
        : "",
      driving_license_number: form.driving_license_number
        ? form.driving_license_number
        : "",
      validity_period_driving_license: form.validity_period_driving_license
      ? form.validity_period_driving_license
      :"2050-12-31",
      total_min:
        Number(form.shift_end_hour) * 60 +
        Number(form.shift_end_min) -
        (Number(form.shift_start_hour) * 60 + Number(form.shift_start_min)),
    };
    for (const key in datajob) {
      const option = validDriver(key, datajob[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }

    setError(errors);
    if (validateSubmit(errors)) {
      try {
        const formData = new FormData();
        formData.append("driver", JSON.stringify(driver));
        // formData.append("driver_photo",selectedFileList[0].originFileObj );

        if (selectedFileList && selectedFileList !== null) {
          formData.append("driver_photo", selectedFileList[0]?.originFileObj);
        }
        if (selectedFileList2 && selectedFileList2 !== null) {
          formData.append("license_photo", selectedFileList2[0]?.originFileObj);
        }
        let param =
          "CLIENT_ID=1231278asdbaiaerrs&RESOURCE_USER_ID=13&GROLOG_ACCOUNT_ID=1";
        let res = await doPost(`/driver?${param}`, token, formData);
        setSuccessModalOpen(true);
      } catch (err) {
        message.error(_.startCase(err.response.data.payload.message));
      }
    }
  };


  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    let errors = {};
    let sub = {
      first_name: form?.first_name ? form.first_name : "",
      last_name: form?.last_name ? form.last_name : "",
      birth_date: "1945-08-17",
      gender: form?.gender ? form.gender : "",
      nik: form?.nik ? form.nik : "",
      phone: form?.phone ? form.phone : "",
      email: form?.email ? form.email : "",
      marital_status: form?.marital_status ? form.marital_status : "",
      country_id: form?.country ? form.country : "",
      island_id: form?.island ? form.island : "",
      province_id: form?.province ? form.province : "",
      district_id: form?.district ? form.district : "",
      sub_district_id: form?.sub_district ? form.sub_district : "",
      urban_village_id: form?.urban_village ? form.urban_village : "",
      address: form?.address ? form.address : "",
      neighbourhood: form?.neighbourhood ? form.neighbourhood : "",
      hamlet: form?.hamlet ? form.hamlet : "",
      postal_code: form?.postal_code ? form.postal_code : "",
      longitude: form?.longitude ? form.longitude : "",
      latitude: form?.latitude ? form.latitude : "",
      emergency_contact_name: form?.emergency_contact_name
        ? form.emergency_contact_name
        : "",
      emergency_contact_relationship: form?.emergency_contact_relationship
        ? form.emergency_contact_relationship
        : "",
      emergency_contact_phone: form?.emergency_contact_phone
        ? form.emergency_contact_phone
        : "",
      emergency_contact_address: form?.emergency_contact_address
        ? form.emergency_contact_address
        : "",
    };
    for (const key in sub) {
      const option = validDriver(key, sub[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      setPage(2);
    }
  };

  const DriverProfile = () => {
    return (
      <>
        <div className="flex">
          <div>
            {/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
              {t("CUSTOMER:DRIVER_PROFILE")}
            </h3> */}
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("Driver Profile")}
                  </h3>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Driver Photo")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Dragger
                    selectedFileList={selectedFileList}
                    setSelectedFileList={setSelectedFileList}
                    // loadingFile={loadingFile}
                    // setLoadingFile={setLoadingFile}
                    // errorSize={errorSize}
                    // setErrorSize={setErrorSize}
                    // fileUrl ={fileUrl}
                    // setFileUrl={setFileUrl}
                  />
                  {/* <Input
                      className="mt-[8px] h-[47px] w-[500px]"
                      onChange={(value) => handleChange(value, "")}
                    /> */}
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Title")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Select
                    className="w-[500px]"
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.title}
                    onChange={(value) => handleChange(value, "title")}
                    onPopupScroll={(e) => onScrollTitle(e)}
                    loading={loading}
                    // options={Title}
                    placeholder="Select Title"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeTitle(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? title : [...title, LoadingOption()]}
                  </Select>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("CUSTOMER:FIRST_NAME")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "first_name")}
                    status={error?.first_name ? "error" : ""}
                    value={form.first_name}
                  />

                  <div className="text-red-100">{error?.first_name}</div>
                </div>

                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("CUSTOMER:LAST_NAME")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "last_name")}
                    status={error?.last_name ? "error" : ""}
                    value={form.last_name}
                  />

                  <div className="text-red-100">{error?.last_name}</div>
                </div>

                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Birth Date")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <DatePicker
                  disabledDate={(current)=> {
                    return current && current.isAfter(moment().format('DD MMMM YYYY'))
                  }}
                    format={"DD MMMM YYYY"}
                    onChange={(e) => handleChange(e, "birth_date")}
                    showToday={false}
                    value={form.birth_date ? dayjs(form.birth_date) : ""}
                    suffixIcon={<img src={DateIcon} alt="date" />}
                    className="mt-[8px] h-[47px] w-[500px]"
                    allowClear={true}
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Gender")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <div className={style.radio}>
                    <Radio.Group
                      onChange={(value) => handleChange(value, "gender")}
                      value={form.gender}
                      // defaultValue="view"
                      className="flex"
                    >
                      <Radio value="L">Male</Radio>
                      <Radio value="P">Female</Radio>
                    </Radio.Group>
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("CUSTOMER:NIK")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "nik")}
                    status={error?.nik ? "error" : ""}
                    value={form.nik}
                  />

                  <div className="text-red-100">{error?.nik}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("CUSTOMER:PHONE")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      value="+62"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => handleChange(value, "phone")}
                      status={error?.phone ? "error" : ""}
                      value={form.phone}
                    />
                  </Space.Compact>

                  <div className="text-red-100">{error?.phone}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("CUSTOMER:EMAIL")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "email")}
                    status={error?.email ? "error" : ""}
                    value={form.email}
                  />

                  <div className="text-red-100">{error?.email}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Marital Status")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Select
                    className="w-[500px]"
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.marital_status}
                    onChange={(value) => handleChange(value, "marital_status")}
                    options={[
                      { value: "Lajang", label: "Lajang" },
                      { value: "Nikah", label: "Nikah" },
                      { value: "Cerai", label: "Cerai" },
                    ]}
                  />
                </div>

                {/* emergency contact */}
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("Emergency Contact")}
                  </h3>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Name")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) =>
                      handleChange(value, "emergency_contact_name")
                    }
                    status={error?.emergency_contact_name ? "error" : ""}
                    value={form.emergency_contact_name}
                  />

                  <div className="text-red-100">
                    {error?.emergency_contact_name}
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Relationship")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    value={form.emergency_contact_relationship}
                    onChange={(value) =>
                      handleChange(value, "emergency_contact_relationship")
                    }
                    status={
                      error?.emergency_contact_relationship ? "error" : ""
                    }
                  />

                  <div className="text-red-100">
                    {error?.emergency_contact_relationship}
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("CUSTOMER:PHONE")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="+62"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) =>
                        handleChange(value, "emergency_contact_phone")
                      }
                      status={error?.emergency_contact_phone ? "error" : ""}
                      value={form.emergency_contact_phone}
                    />
                  </Space.Compact>

                  <div className="text-red-100">
                    {error?.emergency_contact_phone}
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Address")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) =>
                      handleChange(value, "emergency_contact_address")
                    }
                    status={error?.emergency_contact_address ? "error" : ""}
                    value={form.emergency_contact_address}
                  />

                  <div className="text-red-100">
                    {error?.emergency_contact_address}
                  </div>
                </div>
              </div>

              {/* LINE TWO */}

              <div className="gap-[40px] mb-[24px] ml-36">
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("Driver Address")}
                  </h3>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Driver Country")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.country_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.country}
                    onChange={(value) => handleChange(value, "country")}
                    onPopupScroll={(e) => onScrollCountry(e)}
                    loading={loading}
                    // options={Country}
                    placeholder="Select Country"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeCountry(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? country : [...country, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">{error?.country_id}</div>
                </div>
                {/* <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Driver Island")+" (Optional)"}
                  </label>
                  <Select
                    className="w-[500px]"
                    disabled={!form.country}
                    status={error?.island_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.island}
                    onChange={(value) => handleChange(value, "island")}
                    options={island}
                  />
                  <div className="text-red-100">{error?.island_id}</div>
                </div> */}
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Driver Province")}
                  </label>
                  <Select
                    className="w-[500px]"
                    disabled={!form.country}
                    value={form.province}
                    status={error?.province_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    onChange={(value) => handleChange(value, "province")}
                    onPopupScroll={(e) => onScrollProvince(e)}
                    loading={loading}
                    // options={Province}
                    placeholder="Select Province"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeProvince(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? province : [...province, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">{error?.province_id}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Driver District")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.district_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    disabled={!form.province}
                    value={form.district}
                    size="large"
                    onChange={(value) => handleChange(value, "district")}
                    onPopupScroll={(e) => onScrollDistrict(e)}
                    loading={loading}
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeDistrict(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? district : [...district, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">{error?.district_id}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Driver Sub District")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.sub_district_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    disabled={!form.district}
                    value={form.sub_district}
                    onChange={(value) => handleChange(value, "sub_district")}
                    onPopupScroll={(e) => onScrollSubdistrict(e)}
                    loading={loading}
                    // options={Subdistrict}
                    placeholder="Select Subdistrict"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeSubdistrict(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? subdistrict : [...subdistrict, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">{error?.sub_district_id}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Driver Urban Village")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.urban_village_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    disabled={!form.sub_district}
                    value={form.urban_village}
                    onChange={(value) => handleChange(value, "urban_village")}
                    onPopupScroll={(e) => onScrollUrbanvillage(e)}
                    loading={loading}
                    // options={Urbanvillage}
                    placeholder="Select depot Urbanvillage"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeUrbanvillage(value),
                        searchValue
                      )
                    }
                  >
                    {!loading
                      ? urbanvillage
                      : [...urbanvillage, LoadingOption()]}
                  </Select>
                  <div className="text-red-100">{error?.urban_village_id}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Driver Address")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "address")}
                    status={error?.address ? "error" : ""}
                    value={form.address}
                  />

                  <div className="text-red-100">{error?.address}</div>
                </div>
                <div className="w-[500px] mb-[24px] flex">
                  <div>
                    <label className="font-roboto text-[16px] font-medium">
                      {t("CUSTOMER:HAMLET")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                    </label>
                    <Input
                      className="mt-[8px] h-[47px] w-[200px]"
                      onChange={(value) => handleChange(value, "hamlet")}
                      status={error?.hamlet ? "error" : ""}
                      value={form.hamlet}
                    />

                    <div className="text-red-100">{error?.hamlet}</div>
                  </div>
                  <div>
                    <label className="font-roboto text-[16px] font-medium">
                      {t("CUSTOMER:NEIGHBOURHOOD")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                    </label>
                    <Input
                      className="mt-[8px] h-[47px] w-[200px]"
                      onChange={(value) => handleChange(value, "neighbourhood")}
                      status={error?.neighbourhood ? "error" : ""}
                      value={form.neighbourhood}
                    />

                    <div className="text-red-100">{error?.neighbourhood}</div>
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Postal Code")}
                  </label>
                  <Select
                    className="w-[500px]"
                    status={error?.postal_code ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    disabled={!form.urban_village}
                    value={form.postal_code}
                    onChange={(value) => handleChange(value, "postal_code")}
                    options={postalcode}
                  />

                  <div className="text-red-100">{error?.postal_code}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Longitude") + " (Optional)"}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "longitude")}
                    status={error?.longitude ? "error" : ""}
                    value={form.longitude}
                  />

                  <div className="text-red-100">{error?.longitude}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Latitude") + " (Optional)"}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    onChange={(value) => handleChange(value, "latitude")}
                    status={error?.latitude ? "error" : ""}
                    value={form.latitude}
                  />

                  <div className="text-red-100">{error?.latitude}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const JobDesc = () => {
    return (
      <>
        <div className="flex">
          <div>
            {/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
              {t("CUSTOMER:DRIVER_PROFILE")}
            </h3> */}
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("Employment Condition")}
                  </h3>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:EMPLOYMENT_STATUS")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Select
                    className="mt-[8px] h-[47px] w-[500px]"
                    value={form.employment_status}
                    onChange={(value) =>
                      handleChange(value, "employment_status")
                    }
                    options={[
                      { value: 1, label: "Internal" },
                      { value: 2, label: "External" },
                      { value: 3, label: "Outsourching" },
                    ]}
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:REGISTER_DATE")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <DatePicker
                  value={form.register_date ? dayjs(form.register_date) : ""}
                  disabledDate={(current)=> {
                    return current && current.isAfter(moment().format('DD MMMM YYYY'))
                  }}
                    format={"DD MMMM YYYY"}
                    onChange={(e) => handleChange(e, "register_date")}
                    showToday={true}
                    // defaultValue={dayjs(form.register_date)}
                    suffixIcon={<img src={DateIcon} alt="date" />}
                    className="mt-[8px] h-[47px] w-[500px]"
                    allowClear={true}
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:SHIFT_START")}
                  </label>
                  <div className="flex w-[500px]">
                    <Input
                      className="mt-[8px] h-[47px] w-[55px] mr-2"
                      onChange={(value) =>
                        handleChange(value, "shift_start_hour")
                      }
                      onBlur={()=>handleBlur(form.shift_start_hour,"shift_start_hour")}
                      status={error?.shift_start_hour ? "error" : ""}
                      value={form.shift_start_hour}
                    />

                    <div className="text-red-100">
                      {/* {error?.shift_start_hour} */}
                    </div>
                    <img src={DotHour} alt="hour" />
                    <Input
                      className="mt-[8px] h-[47px] w-[55px] ml-2"
                      onChange={(value) =>
                        handleChange(value, "shift_start_min")
                      }
                      onBlur={()=>handleBlur(form.shift_start_min,"shift_start_min")}
                      status={error?.shift_start_min ? "error" : ""}
                      value={form.shift_start_min}
                    />

                    {/* <div className="text-red-100">{error?.shift_start_min}</div> */}
                  </div>
                </div>

                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:SHIFT_END")}
                  </label>
                  <div className="flex w-[500px]">
                    <Input
                      className="mt-[8px] h-[47px] w-[55px] mr-2"
                      onChange={(value) =>
                        handleChange(value, "shift_end_hour")
                      }
                      onBlur={()=>handleBlur(form.shift_end_hour,"shift_end_hour")}
                      status={error?.shift_end_hour ? "error" : ""}
                      value={form.shift_end_hour}
                    />

                    {/* <div className="text-red-100">{error?.shift_end_hour}</div> */}
                    <img src={DotHour} alt="hour" />
                    <Input
                      className="mt-[8px] h-[47px] w-[55px] ml-2"
                      onChange={(value) => handleChange(value, "shift_end_min")}
                      onBlur={()=>handleBlur(form.shift_start_min,"shift_start_min")}
                      status={error?.shift_end_min ? "error" : ""}
                      value={form.shift_end_min}
                    />

                    {/* <div className="text-red-100">{error?.shift_end_min}</div> */}
                  </div>
                </div>

                <div className="text-red-100">{error?.total_min}</div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:DAY_OFF")}
                  </label>
                  <div className="mt-[8px] h-[auto] w-[500px]">
                    {/* <MSSDayOff
                      getValue={(value) => getSalesmanType(value)}
                      level={1}
                      add={true}
                      value={salesmanType}
                      isSelectAll={salesmanType.flagCheckAll}
                      currentValue={
                        salesmanType?.data?.length !== 0 &&
                        salesmanType?.data !== undefined
                          ? salesmanType?.data.map((el) => el.value)
                          : undefined
                      }
                      // error={this.state.error}
                      errorNamespace={"salesman_type_list"}
                    /> */}
                    
        <MSSAddDayOff setVal={setValueDayOff} val={valueDayOff} />
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:DAILY_SALARY")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="IDR"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => handleChange(value, "salary")}
                      status={error?.salary ? "error" : ""}
                      value={form.salary}
                    />
                  </Space.Compact>

                  <div className="text-red-100">{error?.salary}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Hourly Salary")}
                  </label>
                  <Space.Compact>
                    <Input style={{ width: "15%" }} value="IDR" disabled />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      disabled
                      value={form?.salary_per_hour}
                      onChange={(value) =>
                        handleChange(value, "salary_per_hour")
                      }
                    />
                  </Space.Compact>
                </div>
              </div>

              {/* line two */}
              <div className="gap-[40px] mb-[24px] ml-36">
                <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("Vehicle and driving license")}
                  </h3>
                </div>

                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:VEHICLE")}
                  </label>
                  <div className="mt-[8px] h-[47px] w-[500px]">
                    <Select
                      className="w-[500px]"
                      size="large"
                      value={form?.vehicle_id}
                      onChange={(value) => handleChange(value, "vehicle_id")}
                      onPopupScroll={(e) => onScrollVehicle(e)}
                    loading={loading}
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeVehicle(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? vehicle : [...vehicle, LoadingOption()]}
                  </Select>
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:DRIVING_LICENSE_TYPE")}
                  </label>
                  <div className="mt-[8px] h-[47px] w-[500px]">
                    <Select
                      className="w-[500px]"
                      dropdownStyle={{
                        backgroundColor: "white",
                      }}
                      size="large"
                      onChange={(value) =>
                        handleChange(value, "driving_license_type")
                      }
                      value={form.driving_license_type}
                      options={[
                        { value: 1, label: "SIM A" },
                        { value: 2, label: "SIM B1" },
                        { value: 3, label: "SIM B2" },
                        { value: 4, label: "SIM C" },
                        { value: 5, label: "SIM D" },
                      ]}
                    />
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:DRIVING_LICENSE_NUMBER")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    value={form.driving_license_number}
                    onChange={(value) =>
                      handleChange(value, "driving_license_number")
                    }
                    status={error?.driving_license_number ? "error" : ""}
                  />

                  <div className="text-red-100">
                    {error?.driving_license_number}
                  </div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:VALIDITY_PERIOD")}
                  </label>
                  <DatePicker
                    format={"DD MMMM YYYY"}
                    onChange={(e) =>
                      handleChange(e, "validity_period_driving_license")
                    }
                    showToday={true}
                    // defaultValue={dayjs(form.validity_period_driving_license)}
                    value={form.validity_period_driving_license ? dayjs(form.validity_period_driving_license) : ""}
                    suffixIcon={<img src={DateIcon} alt="date" />}
                    className="mt-[8px] h-[47px] w-[500px]"
                    allowClear={true}
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("DRIVER:DRIVING_LICENSE_PHOTO")}<i> {t("VEHICLE_ADD:OPTIONAL_TAG")}</i>
                  </label>
                  <Dragger
                    selectedFileList={selectedFileList2}
                    setSelectedFileList={setSelectedFileList2}
                  />
                </div>
                {additionalProofs?.map((el, index) => {
                  return (
                    <>
                      <div className="w-[500px] mb-[24px]">
                        <label className="font-roboto text-[16px] font-medium">
                          {el?.key + " (Optional)"}
                        </label>
                        <Input
                          className="mt-[8px] h-[47px] w-[500px]"
                          value={el.value}
                          onChange={(value) =>
                            handleChangeAdditional(value, index, el?.key)
                          }
                          // status={error?.driving_license_number ? "error" : ""}
                        />

                        {/* <div className="text-red-100">{error?.driving_license_number}</div> */}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const Tab1 = () => {
    return (
      <>
        {page === true ? (
          <img
            src={TabDriverProfile2}
            alt="tab"
            onClick={() => setPage(false)}
          />
        ) : (
          <img
            src={TabDriverProfile}
            alt="tab"
            onClick={() => setPage(false)}
          />
        )}
      </>
    );
  };
  const Tab2 = () => {
    return (
      <>
        {page === true ? (
          <img src={TabDriverJob2} alt="tab" onClick={() => setPage(true)} />
        ) : (
          <img src={TabDriverJob} alt="tab" onClick={() => setPage(true)} />
        )}
      </>
    );
  };
  const items = [
    {
      key: 1,
      label: Tab1(),
      children: DriverProfile(),
    },
    {
      key: 2,
      label: Tab2(),
      children: JobDesc(),
    },
  ];

  const actModal = () => {
    setSuccessModalOpen(false);
    navigate({
      pathname: ROUTES.DRIVER.LIST,
    });
  };

  return (
    <>
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.DRIVER.LIST}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been added"
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Master`}
          menuLevel2={`Fleet`}
          menuLevel3={`Driver`}
          menuLevel4={`Add Driver`}
        />

        <div className="flex items-center justify-between">
          <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.DRIVER.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />

            <h1 className="font-sans-bold text-2xl" id="title">
              Add Driver
            </h1>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <div className="flex">
              <img src={page === 1 ? TabDriverProfile : TabDriverProfile2} />
              <img src={page === 1 ? TabDriverJob : TabDriverJob2} />
            </div>
            {!load
              ? page === 1
                ? DriverProfile()
                : JobDesc()
              : "loading..."}

            {/* <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            /> */}
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          {page === 1 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => handleNext()}
              />
              <SecondaryButton
                action={
                  change
                    ? () => setShowConfirm(true)
                    : () => navigate(ROUTES.DRIVER.LIST)
                }
                text={t("USER_DETAIL:CANCEL")}
              />
            </>
          ) : (
            <>
              <PrimaryButton text={t("Submit")} action={() => onSubmit()} />
              <SecondaryButton text={t("Previous")} action={() => setPage(1)} />
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default DriverAdd;
